/**
 * This nuxt-auth plugin removes `Set-Cookie` header if user is not logged in
 * Required to enable default cache in Cloudflare
 *
 * @param {*} ctx Nuxt context
 */

export default function (ctx) {
  // act only on server request
  if (process.server) {
    let setCookies = (ctx.res.getHeader('Set-Cookie')) || []
    if (!Array.isArray(setCookies)) setCookies = [setCookies]

    // remove `Set-Cookie: auth.strategy` set by nuxt-auth module if user is not logged in
    // this fixes Cloudflare not caching resources that have Set-Cookie headers
    if (setCookies.length === 1) {
      ctx.res.removeHeader('Set-Cookie')
    }

    // if logged in, multiple cookies are set - requested resource must not be cached
    if (setCookies.length > 1) {
      ctx.res.setHeader('Cache-Control', 'no-store')
    }
  }
}
